import gql from 'graphql-tag';
import { parseToMutationRequest } from 'utils/utils';
import jobNS from './constants/jobNS';
import { getUserId } from '../../localStorages';

export default data => {
  const newData = data;
  newData.userId = getUserId() || newData.userId || null;
  const dataCreate = parseToMutationRequest(newData, jobNS);
  const recreateJobSchedule = `recreateJobSchedule(input: ${dataCreate})`;
  return gql`
  mutation {
    ${recreateJobSchedule} {
      id
      status
      scheduleDate
      userId
      scheduleFrequency
      scheduleName
      jobScheduleList {
        index
        jobId
        predJobId
        nextJobId
        name
        notes
        userId
        scheduleTime
        type
        scheduleType
        status
        count
        countSuccess
        countError
      }
    }
  }
`;
};
